import React, { useState, useEffect } from 'react';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('bragsheet_cookie_consent');
    if (!consent) {
      setVisible(true);
    } else if (consent === 'rejected') {
      disableAnalytics();
    }
  }, []);

  const disableAnalytics = () => {
    // Disable Google Analytics by setting the opt-out property
    window['ga-disable-' + (window.GA_MEASUREMENT_ID || '')] = true;
    // Remove GA cookies
    document.cookie.split(';').forEach(c => {
      const name = c.trim().split('=')[0];
      if (name.startsWith('_ga')) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.' + window.location.hostname;
      }
    });
  };

  const handleAccept = () => {
    localStorage.setItem('bragsheet_cookie_consent', 'accepted');
    if (window.loadGA4) window.loadGA4();
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('bragsheet_cookie_consent', 'rejected');
    disableAnalytics();
    setVisible(false);
  };

  if (!visible) return null;

  // T36: Lighter cookie bar — light background + top border instead of dark fill,
  // lower visual weight to match the app UI. Functionality (consent state, localStorage,
  // GA4 trigger) is unchanged; only the visual treatment was updated.
  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9999,
      backgroundColor: '#f8fafc', color: '#1e293b',
      borderTop: '1px solid #e2e8f0',
      padding: '1rem 1.5rem',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: '1rem', flexWrap: 'wrap', fontSize: '0.85rem',
      boxShadow: '0 -1px 3px rgba(15, 23, 42, 0.04)',
    }}>
      <p style={{ margin: 0, maxWidth: '600px', lineHeight: '1.5', color: '#475569' }}>
        We use cookies for analytics to improve your experience.
        See our <a href="/privacy" style={{ color: '#01696F', textDecoration: 'underline' }}>Privacy Policy</a> for details.
      </p>
      <div style={{ display: 'flex', gap: '0.5rem', flexShrink: 0 }}>
        <button onClick={handleReject} style={{
          padding: '0.5rem 1rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: '600',
          backgroundColor: '#ffffff', color: '#64748b', border: '1px solid #e2e8f0',
          cursor: 'pointer',
        }}>
          Reject
        </button>
        <button onClick={handleAccept} style={{
          padding: '0.5rem 1rem', borderRadius: '6px', fontSize: '0.8rem', fontWeight: '600',
          backgroundColor: '#01696F', color: '#ffffff', border: 'none',
          cursor: 'pointer',
        }}>
          Accept
        </button>
      </div>
    </div>
  );
}
